(ns frontend.components.inputs.text
  (:require
   [common.entity :as entity]
   [common.schema.entities.survey.survey-text-variables :as survey-text-variables]
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [reagent.core :as r]
   [ui.components.tiptap.view :as mention-tiptap]))

(defn mention-variable-ids
  [variable-source]
  (survey-text-variables/variable-ids-for-source variable-source))

(defn render
  [dom-atom args]
  (let [{:keys [:value :placeholder :class-name
                :auto-focus :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled?]}
        args
        edit-value (or (:temp-value @dom-atom) value)
        render-value (str (if (nil? edit-value) value edit-value))
        clear-state! (fn []
                       (swap! dom-atom dissoc :temp-value))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (or placeholder "")
             :class-name  (fu/cs "component-text"
                                 (when (or has-focus?
                                           (:focus? @dom-atom))
                                   "focus")
                                 class-name)
             :value       render-value
             :on-focus    (fn [e]
                            (swap! dom-atom assoc :focus? true)
                            (when-let [input-node (:input-dom-node @dom-atom)]
                              (.select input-node))         ;; all desktop browsers - select all text
                            (let [r (when on-focus! (on-focus! e))]
                              true))
             :on-change   (fn [e]
                            (let [new-value (-> e
                                                .-target
                                                .-value)]
                              (swap! dom-atom assoc :temp-value new-value)
                              (when on-change!
                                (on-change! e new-value))))
             :on-blur     (fn [e]
                            (swap! dom-atom dissoc :focus?)
                            (when on-blur!
                              (on-blur! e render-value clear-state!)))
             :on-key-down (fn [e]
                            (when on-key-down!
                              (on-key-down! e)))
             :auto-focus  (boolean auto-focus)}
            (when disabled?
              {:disabled true}))]))


(defmethod editor :editor.type/text-simple
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Text"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! "hahahah")
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod editor :editor.type/text-mention
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]
    (r/create-class
     {:display-name           "TextMention"
      :component-did-mount    (fn [_]
                                (when set-focusable!
                                  (set-focusable! (fn [_]
                                                    true)))
                                (when set-cancel-edit!
                                  (set-cancel-edit! (fn [_]
                                                      (swap! dom-atom dissoc :temp-value))))
                                (when set-save!
                                  (set-save! (fn [_]
                                               true))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :temp-value))
      :reagent-render         (fn [{:keys [value on-blur! on-change! class-name]
                                    :ui/keys [variable-source]}]
                                (let [edit-value (or (:temp-value @dom-atom) value)
                                      clear-state! (fn []
                                                     (swap! dom-atom dissoc :temp-value))]
                                  [mention-tiptap/view
                                   {:value        edit-value
                                    :class        (fu/cs "min-h-[80px]" class-name)
                                    :trigger-char "{"
                                    :item-texts   (mention-variable-ids variable-source)
                                    :on-change    (fn [text _html _json]
                                                    (swap! dom-atom assoc :temp-value text)
                                                    (when on-change!
                                                      (on-change! nil text)))
                                    :on-blur      (fn [e]
                                                    (when (fn? on-blur!)
                                                      (on-blur! e edit-value clear-state!)))}]))})))

(defmethod display-string :editor.type/text-simple
  [args]
  (let [value (:value args)]
    (cond
      (string? value) value
      (= (:value-type args) :entity) (or (entity/resolve-entity-name (get @session/entities value)
                                                                     session/get-entity
                                                                     session/reverse-lookup)
                                         (entity/display-string (get @session/entities value)))
      :else (str value))))

(defmethod display-string :editor.type/text-mention
  [args]
  (display-string (assoc args :editor/type :editor.type/text-simple)))

(defmethod viewer :editor.type/text-simple
  [args]
  (r/create-class
   {:display-name   "text/viewer"
    :reagent-render (fn [args]
                      [:div.preview.preview-text
                       (display-string args)])}))

(defmethod viewer :editor.type/text-mention
  [args]
  [viewer (assoc args :editor/type :editor.type/text-simple)])
